import { supportQueryKeys as e } from "./supportQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { supportApi as n } from "@maat/api-main";
//#region src/support/useHelpArticleQuery.ts
var r = (r) => t({
	queryKey: e.article(r),
	queryFn: () => n.getHelpArticle(r),
	enabled: !!r
});
//#endregion
export { r as useHelpArticleQuery };
